
import { REHYDRATE } from 'redux-persist';
import { constants } from '../constants/redux-constants'

const initialState = {
  selectedLocations: [],
  selectedDoctors: [],
};

const Appointmentsreducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...state,
        ...action.payload?.appointments || {}
      };
    case constants.RESET:
      return {
        ...initialState
      }
    case constants.APPOINTMENTS.UPDATE_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.payload,
      };
    case constants.APPOINTMENTS.UPDATE_SELECTED_DOCTORS:
      return {
        ...state,
        selectedDoctors: action.payload,
      };
    default:
      return {
        ...state
      }
  }
};

export default Appointmentsreducer;

